import { render, staticRenderFns } from "./disease.vue?vue&type=template&id=826ab768&scoped=true"
import script from "./disease.vue?vue&type=script&lang=js"
export * from "./disease.vue?vue&type=script&lang=js"
import style0 from "./disease.vue?vue&type=style&index=0&id=826ab768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826ab768",
  null
  
)

export default component.exports